import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CurrentFilterSet, SsoUsersList } from './api/types';
// import ssoStudentsSlice from './store/sso-students.slice';
import ssoTeachersSlice from './store/sso-teachers.slice';

@Injectable({
  providedIn: 'root',
})
export class SsoTeachersService {
  constructor(private readonly store: Store<unknown>) {}

  setCurrentFilterAndTeachers(
    currentFilter: CurrentFilterSet,
    usersList: SsoUsersList
  ): void {
    this.store.dispatch(
      ssoTeachersSlice.actions.setCurrentFilterAndUsers({
        currentFilter: currentFilter,
        usersList: usersList,
      })
    );
  }
  getCurrentFilterAndTeachers(): Observable<{
    currentFilter: CurrentFilterSet;
    usersList: SsoUsersList;
  }> {
    return ssoTeachersSlice.select(this.store, (state: any) => state);
  }
}
